import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SliderComponent, SliderSlideDirective } from '@libs/common/components';
import { ProductImpressionDirective } from '@libs/shared/tracking';
import { AddToCartModel, ProductModel } from '@libs/shop/models';
import { ProductCardSmallComponent } from '../../catalog/product-card-small/product-card-small.component';
import { ProductCardComponent } from '../../catalog/product-card/product-card.component';

@Component({
  selector: 'ui-product-slider',
  imports: [ProductCardComponent, SliderComponent, SliderSlideDirective, ProductImpressionDirective, ProductCardSmallComponent],
  templateUrl: './product-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSliderComponent {
  public products: InputSignal<ProductModel[]> = input.required();

  public highlightedProducts: InputSignal<ProductModel[]> = input([] as ProductModel[]);

  public autoplay: InputSignal<boolean> = input(false);

  public navigation: InputSignal<boolean> = input(true);

  public duration: InputSignal<number> = input(3000);

  public small: InputSignal<boolean> = input(false);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Output()
  public addToShoppingList: EventEmitter<AddToCartModel<ProductModel>> = new EventEmitter<AddToCartModel<ProductModel>>();
}
